import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
var ReturnBannerSection = function ReturnBannerSection() {
  var _useTranslation = useTranslation(),
    tLong = _useTranslation.tLong;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "pt-12 pb-10 px-4 md:pb-[64px] md:max-w-[1152px] md:mx-auto md:px-0 md:pt-[78px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-primary rounded-2xl py-10 px-3 flex flex-col justify-center items-center gap-9 relative overflow-hidden md:flex-row-reverse md:justify-between md:px-10 md:py-[72px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-6 h-[190px] md:px-0 md:w-[287px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: lang === "ar" ? CDN_LINK + "/assets/images/about-us/return-banner-text.svg" : CDN_LINK + "/assets/images/about-us/return-banner-text-en.svg",
    alt: tLong("about_us/return_banner_text_alt", {
      ns: "web_common"
    }),
    className: "w-full h-full object-contain object-center",
    loading: "lazy",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 px-3 md:items-start md:px-0"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-white text-center text-2xl font-bold md:text-[32px] md:max-w-[465px] md:text-start md:leading-normal"
  }, tLong("about_us/return_banner_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-base font-medium text-white md:text-2xl md:max-w-[465px]"
  }, tLong("about_us/return_banner_subtitle", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-[545px] h-[545px] rounded-full border-[160px] border-solid border-[#F1F6FC] absolute bottom-[-330px] right-[-320px] opacity-[0.2]"
  }))));
};
export default ReturnBannerSection;